import appstore from "../Images/appstore.png";
import footerlogo_ar from "../Images/arabic-logo.png";
import playstore from "../Images/playstore.png";
import footerlogo_en from "../Images/tararide_header.png";

import { Link, NavLink } from "react-router-dom";
import QRSection from "./QRSection";

import { useTranslation } from "react-i18next";

function Footer() {
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language.startsWith("ar") ? "ar" : "en";
  const footerLogo = currentLang === "ar" ? footerlogo_ar : footerlogo_en;

  return (
    <>
      <footer className="footer-section-wrapping">
        <div className="container">
          <div className="row gy-4">
            {/* Logo + About */}
            <div className="col-lg-4 col-md-6 footer-about">
              <img src={footerLogo} className="header-logo" alt="logo" />

              <p>{t("footer_desc")}</p>

              <div className="footer-social-icons">
                <span>
                  <Link to="tel:+201287690960">
                    <i className="fa-brands fa-whatsapp"></i>
                  </Link>
                </span>
                <span>
                  <i className="fa-brands fa-instagram"></i>
                </span>
                <span>
                  <i className="fa-brands fa-facebook"></i>
                </span>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6 footer-contact">
              <h4>{t("contact_title")}</h4>
              <ul>
                <li>
                  <i className="fas fa-map-pin pe-2"></i> {t("address")}
                </li>
                <li>
                  <i className="fa-solid fa-envelope pe-2"></i>
                  <a
                    href={`mailto:${t("email")}`}
                    className="contact-link text-decoration-none"
                    style={{ color: "#dcdcdc" }}
                  >
                    {t("email")}
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-phone pe-2"></i>
                  <a
                    href={`tel:${t("phone")}`}
                    className="contact-link text-decoration-none"
                    style={{ color: "#dcdcdc" }}
                  >
                    {t("phone")}
                  </a>
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 footer-links">
              <h4>{t("quick_links")}</h4>
              <ul>
                <li>
                  <NavLink to="/" end className="footer-link">
                    {t("home")}
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/about-us" className="footer-link">
                    {t("about")}
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/services" className="footer-link">
                    {t("services")}
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/choose-us" className="footer-link">
                    {t("choose")}
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/contact-us" className="footer-link">
                    {t("contact")}
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Download App / Gallery */}
            <div className="col-lg-3 col-md-6 footer-gallery">
              <h4>{t("download_app")}</h4>
              <div className="app-icon">
                <div className="mb-3">
                  <Link
                    to="https://play.google.com/store/apps/developer?id=Emadr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={playstore} alt="Play Store" />
                  </Link>
                </div>
                <div>
                  <Link
                    to="https://apps.apple.com/us/developer/emad-ramzy/id1699778983"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={appstore} alt="App Store" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="d-flex justify-content-between mt-4">
          <div className="af-footer-bottom text-center d-flex align-items-center justify-content-center">
        <p className="">
          Copyright © <span id="year">{new Date().getFullYear()}</span>{" "}
          TaraRide.  All Rights Reserved | Developed
          By :
          <Link
            to="https://apliket.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-1"
          >
            Apliket Technologies
          </Link>
        </p>

        
      </div>
           <div className="d-flex justify-content-end gap-3">
          <Link to="/privacy-policy" className="text-decoration-none" style={{ color: "#dcdcdc" }}>
              <h6>privacy & policy</h6>
            </Link>
            <Link to="/terms-condition" className="text-decoration-none" style={{ color: "#dcdcdc" }}>
              <h6>Terms & Condition</h6>
            </Link>
        </div>
        </div> */}
        {/* <div className="position-relative mt-4">


  <div className="text-center">
    <p className="mb-0">
      Copyright © {new Date().getFullYear()} TaraRide. All Rights Reserved | Developed By :
      <Link
        to="https://apliket.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="ms-1 text-decoration-none text-white"
      >
        Apliket Technologies
      </Link>
    </p>
  </div>

  
  <div className="position-absolute end-0 top-50 translate-middle-y d-flex gap-3 pe-5">
    <Link to="/privacy-policy" className="text-decoration-none" style={{ color: "#dcdcdc" }}>
      <h6 className="mb-0">Privacy Policy</h6>
    </Link>
           <div style={{ width: "1px", height: "16px", background: "#777" }}></div>
    <Link to="/terms-condition" className="text-decoration-none" style={{ color: "#dcdcdc" }}>
      <h6 className="mb-0">Terms & Condition</h6>
    </Link>
  </div>

</div> */}
        <div className="position-relative mt-4 text-center">
          <p className="mb-0">
            Copyright © {new Date().getFullYear()} TaraRide. All Rights Reserved
            | Developed By :
            <a
              href="https://apliket.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="ms-1 text-decoration-none text-white"
            >
              Apliket Technologies
            </a>
          </p>

          <div className="footer-links d-none d-md-flex position-absolute end-0 top-50 translate-middle-y align-items-center gap-2 pe-4">
            <Link
              to="/privacy-policy"
              className="text-decoration-none"
              style={{ color: "#dcdcdc" }}
            >
              <span>{t("privacy_link")}</span>
            </Link>

            <div
              style={{ width: "1px", height: "16px", background: "#777" }}
            ></div>

            <Link
              to="/terms-condition"
              className="text-decoration-none"
              style={{ color: "#dcdcdc" }}
            >
              <span>{t("terms_link")}</span>
            </Link>
          </div>

          <div className="d-flex d-md-none justify-content-center gap-2 mt-2">
            <Link
              to="/privacy-policy"
              className="text-decoration-none"
              style={{ color: "#dcdcdc" }}
            >
              <span>{t("privacy_link")}</span>
            </Link>

            <div
              style={{ width: "1px", height: "16px", background: "#777" }}
            ></div>

            <Link
              to="/terms-condition"
              className="text-decoration-none"
              style={{ color: "#dcdcdc" }}
            >
              <span>{t("terms_link")}</span>
            </Link>
          </div>
        </div>
      </footer>
      <div className="backtotop-wrap2">
        {/* <span className="whatsapp-tooltip2">
         Get Product Details on WhatsApp
        </span> */}

        <a
          href="https://wa.me/201287690960"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa-brands fa-whatsapp text-white"></i>
        </a>
      </div>

      <div className="backtotop-wrap1">
        {/* <span className="whatsapp-tooltip2">
         Get Product Details on WhatsApp
        </span> */}

        <QRSection />
      </div>
    </>
  );
}

export default Footer;
